import { gql } from '@apollo/client';

export const GET_LIST_TICKETS = gql`
query Filterlisttickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $ticketStatus: String, $pricingMode: String = "%", $ticketPricingMethod: String = "%", $barcodeStatusFilter: getmanageticket_bool_exp = {}, $onHoldIn: [Boolean!] = [true, false], $lastPricedFrom: timestamptz = "0001-01-01T00:00:00Z", $lastPricedTo: timestamptz = "9999-12-31T23:59:59.999Z", $lastPricedRangeIncludeNull: Boolean = true, $pidStatusFilter: getmanageticket_bool_exp = {}, $vlShareFilter: getmanageticket_bool_exp = {}, $vlSupportFilter: getmanageticket_bool_exp = {}) {
  filterlisttickets(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid, ticket_status:$ticketStatus, payment_status:null}, 
    where: {
      tp_status: { _eq: "List" },
      tp_is_published: { _eq: true },
      u_pricing_mode: { _ilike: $pricingMode },
      # Do not put tp_pricing_method / tp_barcode_attached / on_hold at top level —
      # _ilike and _in exclude NULL and wipe the Listed tab for older seats.
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]},
        { _or: [
          { tp_pricing_method: { _is_null: true } },
          { tp_pricing_method: { _ilike: $ticketPricingMethod } }
        ]},
        $barcodeStatusFilter,
        { _or: [
          { on_hold: { _is_null: true } },
          { on_hold: { _in: $onHoldIn } }
        ]},
        { _or: [
          { last_priced_at: { _is_null: $lastPricedRangeIncludeNull } },
          { last_priced_at: { _gte: $lastPricedFrom, _lte: $lastPricedTo } }
        ]},
        $pidStatusFilter,
        $vlShareFilter,
        $vlSupportFilter
      ]
    }, 
    limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_seat_mode
    tp_internal_notes
    tp_external_notes
    lc_id
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    ticket_user {
      u_fee_percentage
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }, limit: 4) {
        n_type
        n_content
      }
    }
    e_id
    t_id
    tp_id
    tp_vl_production_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_pricing_method
    tp_status
    tp_vl_marketplaces
    tp_vl_share
    tp_validity_status
    tp_is_published
    on_hold
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    last_priced_at
    tp_is_support_vanderbilt_nil_fund
    tp_barcode
    tp_barcode_attached
    tp_barcode_status
    user {
      u_role
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid, ticket_status:$ticketStatus, payment_status:null}, 
    where: {
      tp_status: { _eq: "List" },
      tp_is_published: { _eq: true },
      u_pricing_mode: { _ilike: $pricingMode },
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]},
        { _or: [
          { tp_pricing_method: { _is_null: true } },
          { tp_pricing_method: { _ilike: $ticketPricingMethod } }
        ]},
        $barcodeStatusFilter,
        { _or: [
          { on_hold: { _is_null: true } },
          { on_hold: { _in: $onHoldIn } }
        ]},
        { _or: [
          { last_priced_at: { _is_null: $lastPricedRangeIncludeNull } },
          { last_priced_at: { _gte: $lastPricedFrom, _lte: $lastPricedTo } }
        ]},
        $pidStatusFilter,
        $vlShareFilter,
        $vlSupportFilter
      ]
    }) {
    aggregate {
      count
    }
  }
  FilterListed_allTab_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid, ticket_status:$ticketStatus, payment_status:null},
    where: {
      tp_status: { _eq: "List" },
      tp_is_published: { _eq: true },
      u_pricing_mode: { _ilike: $pricingMode },
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]},
        { _or: [
          { tp_pricing_method: { _is_null: true } },
          { tp_pricing_method: { _ilike: $ticketPricingMethod } }
        ]},
        { _or: [
          { last_priced_at: { _is_null: $lastPricedRangeIncludeNull } },
          { last_priced_at: { _gte: $lastPricedFrom, _lte: $lastPricedTo } }
        ]},
      ]
    }) {
    aggregate {
      count
    }
  }
  FilterListed_onHold_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:$ticketId, tpid:$ticketPlacementId, array_tpid:$array_tpid, ticket_status:$ticketStatus, payment_status:null},
    where: {
      tp_status: { _eq: "List" },
      tp_is_published: { _eq: true },
      u_pricing_mode: { _ilike: $pricingMode },
      on_hold: { _eq: true },
      _and: [
        { _or: [
          { e_name: { _ilike: $search_event } },
          { e_address: { _ilike: $search_event } },
          { l_name: { _ilike: $search_event } }
        ]},
        { _or: [
          { full_name: { _ilike: $search_client } },
          { u_email_id: { _ilike: $search_client } },
          { u_original_email: { _ilike: $search_client } }
        ]},
        { _or: [
          { tp_pricing_method: { _is_null: true } },
          { tp_pricing_method: { _ilike: $ticketPricingMethod } }
        ]},
        $barcodeStatusFilter,
        { _or: [
          { last_priced_at: { _is_null: $lastPricedRangeIncludeNull } },
          { last_priced_at: { _gte: $lastPricedFrom, _lte: $lastPricedTo } }
        ]},
      ]
    }) {
    aggregate {
      count
    }
  }
}
`;

export const GET_LISTED_TICKET_COSTS = gql`
  query GetListedTicketCosts($tp_ids: [uuid!]!) {
    ticket_placement(where: { tp_id: { _in: $tp_ids }, tp_status: { _in: [List, Sold] } }) {
      tp_id
      tp_cost
      ticket {
        user {
          u_fee_percentage
          u_pricing_mode
        }
      }
    }
  }
`;

export const UPDATE_LISTED_TICKET_COST = gql`
  mutation UpdateListedTicketCost($tp_id: uuid!, $tp_cost: numeric) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id }, tp_status: { _in: [List, Sold] } }
      _set: { tp_cost: $tp_cost }
    ) {
      affected_rows
      returning {
        tp_id
        tp_cost
      }
    }
  }
`;

/**
 * Verification / manage tickets query.
 * Step 1 fields for Admin Verification: e_name, e_date (+ e_time_zone for event time),
 * tp_section, tp_row, tp_seat_no, tp_status (ToBeVerified). VL submit is a later step.
 */
export const GET_MANAGE_TICKETS = gql`
query Filtermanagetickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketStatus: String, $ticketId: uuid, $tpId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $day: Int, $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $pricingMode: String = "%", $verificationCutoff: timestamptz) {
  filtermanagetickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:[ToBeVerified, Verified]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]},{_not:{_and:[{tp_status:{_eq:ToBeVerified}},{tp_updated_at:{_lte:$verificationCutoff}}]}}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_seat_mode
    tp_internal_notes
    tp_external_notes
    lc_id
    tp_status
    on_hold
    tp_list_price
    tp_pricing_method
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    ticket_user {
      u_fee_percentage
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }, limit: 4) {
        n_type
        n_content
      }
    }
    tp_vl_marketplaces
    tp_vl_share
    tp_validity_status
    tp_is_published
    e_id
    t_id
    tp_id
    e_status
    user {
      u_role
    }
    full_name
    u_email_id
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    last_priced_at
    tp_is_support_vanderbilt_nil_fund
    tp_barcode
    tp_barcode_status
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:$ticketStatus,day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:[ToBeVerified, Verified]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]},{_not:{_and:[{tp_status:{_eq:ToBeVerified}},{tp_updated_at:{_lte:$verificationCutoff}}]}}]}) {
    aggregate {
      count
    }
  }
  FilterManageTickets_toBeVerified_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:"ToBeVerified",day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_eq:ToBeVerified},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]},{_or:[{tp_updated_at:{_gt:$verificationCutoff}},{tp_updated_at:{_is_null:true}}]}]}) {
    aggregate {
      count
    }
  }
  FilterManageTickets_verified_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:"Verified",day:$day,ticketid:$ticketId,tpid:$tpId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_eq:Verified},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_SOLD_TICKETS = gql`
query FilterSoldTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $paymentStatus: String, $ticketStatus: String, $payoutType: String = null, $pricingMode: String = "%", $stripeAccountFilter: user_bool_exp = {}, $barcodeStatusFilter: getmanageticket_bool_exp = {}) {
  FilterSoldTickets: filterlisttickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:$paymentStatus,ticket_status:$ticketStatus,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},user:$stripeAccountFilter,_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]},$barcodeStatusFilter],tp_status:{_in:["Sold","PaidManuallyViaQA","QADeniedPayout","UnderReview"]}}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_internal_notes
    tp_external_notes
    lc_id
    tp_status
    on_hold
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    ticket_user {
      u_fee_percentage
      u_sales_reps_id
      sales_reps {
        sr_commission_rate
        sr_first_name
        sr_last_name
      }
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }, limit: 4) {
        n_type
        n_content
      }
    }
    e_id
    t_id
    tp_id
    tp_vl_listing_id
    tp_vl_item_id
    tp_wrong_pid
    tp_vl_production_id
    tp_stubhub_id
    tp_seatgeek_id
    u_full_name: full_name
    u_email_id
    tp_logitix_amount
    tp_sold_amount
    tp_payment_status
    tp_list_price
    tp_quick_cut_amount
    tp_sales_rep_commission_override
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_payout_status
    tp_updated_at
    last_priced_at
    tp_is_support_vanderbilt_nil_fund
    tp_barcode
    tp_barcode_attached
    tp_barcode_status
    user {
      u_role
      u_stripe_account_id
      u_stripe_transfers_status
      u_stripe_account_is_due
    }
  }
  FilterSoldTickets_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:$paymentStatus,ticket_status:$ticketStatus,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},user:$stripeAccountFilter,_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]},$barcodeStatusFilter],tp_status:{_in:["Sold","PaidManuallyViaQA","QADeniedPayout","UnderReview"]}}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_soldOpen_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:"NotInitiated",ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_settled_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:"Success",ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_inProgress_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:"Inprogress",ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_failed_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:"Failed",ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:"Sold"}}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_paidManuallyViaQA_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:null,ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},tp_status:{_eq:"PaidManuallyViaQA"},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_qaDeniedPayout_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:null,ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},tp_status:{_eq:"QADeniedPayout"},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_underReview_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:null,ticket_status:null,payout_type:$payoutType}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},tp_status:{_eq:"UnderReview"},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterSoldTickets_voidedPayout_aggregate: filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:null,ticket_status:null,payout_type:"Voided_Payout"}, where: {tp_is_published:{_eq:true},u_pricing_mode:{_ilike:$pricingMode},tp_status:{_eq:"Sold"},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterlisttickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,payment_status:null,ticket_status:null,payout_type:null}, where: {_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}],tp_status:{_eq:List}}) {
    aggregate {
      count
    }
  }
  filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticket_status:null,day:null,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid}, where: {tp_is_published:{_eq:false},tp_status:{_in:[ToBeVerified, Verified]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }

  filterreturntickets_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:["Delist","DelistInProgress","DelistRequested","Return"]},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterUnsoldTickets_aggreagate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:["Unsold"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  filterListingRequestCancelledTickets_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:["ListingRequestCancelled"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

/**
 * Delisted / return / unsold / cancelled / expired tabs.
 * QA Hasura does not expose filterreturntickets; filtermanagetickets with
 * ticket_status and day null is equivalent. Aliases keep response field names.
 */
export const GET_DELIST_AND_RETURN_TICKETS = gql`
query Filterreturntickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $ticketStatus: String, $pricingMode: String = "%", $delistedStatuses: [String!]! = ["Delist", "DelistInProgress", "DelistRequested", "Return"]) {
  filterreturntickets: filtermanagetickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:$delistedStatuses},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_internal_notes
    tp_external_notes
    lc_id
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    ticket_user {
      u_fee_percentage
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }, limit: 4) {
        n_type
        n_content
      }
    }
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    tp_barcode
    user {
      u_role
    }
    u_pricing_mode
  }
  filterreturntickets_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:$delistedStatuses},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterDelisted_allTab_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:["Delist","DelistInProgress","DelistRequested","Return"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterDelisted_delist_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_eq:"Delist"},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterDelisted_delistInProgress_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:["DelistInProgress","DelistRequested"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
  FilterDelisted_return_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_eq:"Return"},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_LISTING_REQUEST_CANCELLED_TICKETS = gql`
query FilterListingRequestCancelledTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $pricingMode: String = "%") {
  filterListingRequestCancelledTickets: filtermanagetickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:["ListingRequestCancelled"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_internal_notes
    tp_external_notes
    lc_id
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    ticket_user {
      u_fee_percentage
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }, limit: 4) {
        n_type
        n_content
      }
    }
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_delist_requested_email
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    tp_barcode
    user {
      u_role
    }
    u_pricing_mode
  }
  filterListingRequestCancelledTickets_aggregate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:["ListingRequestCancelled"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_DELIST_AND_UNSOLD_TICKETS = gql`
query FilterUnsoldTickets ($enddate: date, $leagueId: uuid, $startdate: date, $ticketId: uuid, $ticketPlacementId: uuid, $pageSize: Int, $pageOffset: Int, $order_by: [getmanageticket_order_by!], $search_event: String = "%", $search_client: String = "%", $array_tpid: jsonb, $ticketStatus: String, $pricingMode: String = "%") {
  filterUnsoldTickets: filtermanagetickets(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:["Unsold"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}, limit: $pageSize, offset: $pageOffset, order_by: $order_by) {
    e_name
    l_name
    e_date
    e_address
    tp_section
    tp_row
    tp_seat_no
    tp_internal_notes
    tp_external_notes
    lc_id
    u_id
    u_first_name
    u_last_name
    u_pricing_mode
    ticket_user {
      u_fee_percentage
      user_notes(where: { n_type: { _in: ["internal", "external"] } }, order_by: { n_created_at: desc }, limit: 4) {
        n_type
        n_content
      }
    }
    e_id
    t_id
    tp_id
    u_full_name: full_name
    u_email_id
    tp_list_price
    tp_status
    u_original_email
    e_brand_name
    e_status
    e_time_zone
    e_date_time_zone
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    tp_barcode
    user {
      u_role
    }
    u_pricing_mode
  }
  filterUnsoldTickets_aggreagate: filtermanagetickets_aggregate(args: {enddate:$enddate,leagueid:$leagueId,startdate:$startdate,ticketid:$ticketId,tpid:$ticketPlacementId,array_tpid:$array_tpid,ticket_status:null,day:null}, where: {tp_status:{_in:["Unsold"]},u_pricing_mode:{_ilike:$pricingMode},_and:[{_or:[{e_name:{_ilike:$search_event}},{e_address:{_ilike:$search_event}},{l_name:{_ilike:$search_event}}]},{_or:[{full_name:{_ilike:$search_client}},{u_email_id:{_ilike:$search_client}},{u_original_email:{_ilike:$search_client}}]}]}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_LEAGUES_LIST = gql`
query LeaguesDropdownFilter {
  leagues(where: {l_deleted_at: {_is_null: true}}) {
    l_id
    l_name
  }
}
`;

export const VALIDATE_UPDATE = gql`
  mutation UpdateTicketStatus ($isValid: Boolean, $ticketPlacementId: [uuid!]!, $isUndoRequest: Boolean) {
    updateTicketStatus(ticketPlacementId: $ticketPlacementId, isValid: $isValid, isUndoRequest: $isUndoRequest) {
      message
    }
  }
`;

export const PUBLISH_TICKETS = gql`
mutation publishTickets($publishTicketsInput: PublishTicketsInput!) {
  publishTickets(publishTicketInput: $publishTicketsInput) {
    message
  }
}
`;

export const RETURN_TICKET = gql`
mutation UpdateReturnTickets ($ticketPlacementId: [String!]!) {
  returnTickets(ticketPlacementId: $ticketPlacementId) {
    message
  }
}
`;

export const UNDO_DELIST_REQUEST_TO_LIST = gql`
  mutation UndoDelistRequestToList($tpId: uuid!) {
    undoDelistRequestToList(tpId: $tpId) {
      message
    }
  }
`;

export const UPDATE_TICKET_DETAILS = gql`
  mutation UpdateTicketDetails($editTicketsInput: EditTicketsInput!) {
    editTickets(editTicketsInput: $editTicketsInput) {
      message
      requiresConfirmation
    }
  }
`;

export const UPDATE_TICKET_DETAILS_DIRECT = gql`
mutation UpdateTicketDetailsDirect($tp_id: uuid!, $section: String, $row: String, $seatNumbers: Int) {
  update_ticket_placement(
    where: { tp_id: { _eq: $tp_id } }
    _set: {
      tp_section: $section
      tp_row: $row
      tp_seat_no: $seatNumbers
    }
  ) {
    returning {
      tp_id
      tp_section
      tp_row
      tp_seat_no
      tp_internal_notes
      tp_external_notes
    }
  }
}
`;

/** Apply section/row to sibling seats in a VL listing group (keeps each seat number). */
export const UPDATE_SIBLING_TICKET_SECTION_ROW = gql`
  mutation UpdateSiblingTicketSectionRow(
    $tp_ids: [uuid!]!
    $section: String!
    $row: String!
  ) {
    update_ticket_placement(
      where: { tp_id: { _in: $tp_ids } }
      _set: { tp_section: $section, tp_row: $row }
    ) {
      affected_rows
      returning {
        tp_id
        tp_section
        tp_row
        tp_seat_no
        tp_internal_notes
        tp_external_notes
      }
    }
  }
`;

export const GET_TRACKING_COUNTS = gql`
  query GetTrackingCounts {
    listingExpired: tickets_aggregate(where: { 
      tp_status: { _eq: ListingRequestExpired } 
    }) {
      aggregate {
        count
      }
    }
    failedTransfer: tickets_aggregate(where: { 
      tp_status: { _eq: ToBeVerified }
    }) {
      aggregate {
        count
      }
    }
  }
`;

export const UPDATE_TICKET_STATUS = gql`
  mutation UpdateTicketStatus($tp_id: uuid, $status: ticket_placement_status_type_enum!) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id } }
      _set: { tp_status: $status }
    ) {
      returning {
        tp_id
        tp_status
      }
    }
  }
`;

export const UPDATE_TICKET_PAYMENT_STATUS = gql`
  mutation UpdateTicketPaymentStatus($tp_id: uuid!, $set: ticket_placement_set_input!) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id }, tp_status: { _eq: Sold } }
      _set: $set
    ) {
      returning {
        tp_id
        tp_status
        tp_payment_status
      }
    }
  }
`;

export const UPDATE_TICKETS_PAYMENT_STATUS = gql`
  mutation UpdateTicketsPaymentStatus($tp_ids: [uuid!]!, $set: ticket_placement_set_input!) {
    update_ticket_placement(
      where: { tp_id: { _in: $tp_ids }, tp_status: { _eq: Sold } }
      _set: $set
    ) {
      affected_rows
      returning {
        tp_id
        tp_status
        tp_payment_status
      }
    }
  }
`;

export const RESTORE_CANCELLED_LISTING_TO_VERIFICATION = gql`
  mutation RestoreCancelledListingToVerification($tp_id: uuid!, $updated_at: timestamptz!) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id } }
      _set: {
        tp_status: ToBeVerified
        tp_is_published: false
        tp_validity_status: null
        tp_deleted_at: null
        tp_delist_requested_email: null
        tp_updated_at: $updated_at
      }
    ) {
      returning {
        tp_id
        tp_status
        tp_is_published
      }
    }
  }
`;

export const GET_TICKETS_TO_AUTO_EXPIRE = gql`
  query GetTicketsToAutoExpire($pricingMode: String = "%") {
    filtermanagetickets(
      args: {enddate:null, leagueid:null, startdate:null, ticket_status:null, day:null, ticketid:null, tpid:null, array_tpid:null}
      where: {
        _and: [
          {tp_is_published:{_eq:false}},
          {tp_status:{_in:["ToBeVerified","Verified"]}},
          {u_pricing_mode:{_ilike:$pricingMode}}
        ]
      }
      limit: 5000
    ) {
      tp_id
      e_date
      e_date_time_zone
    }
    ticket_placement(
      where: {
        _and: [
          {tp_is_published:{_eq:false}},
          {tp_status:{_in:[ToBeVerified, Verified]}},
          {tp_deleted_at:{_is_null:true}},
          {ticket:{t_deleted_at:{_is_null:true}}}
        ]
      }
      limit: 5000
    ) {
      tp_id
      ticket {
        event {
          e_date
          e_date_time_zone
        }
      }
    }
  }
`;

export const BULK_EXPIRE_TICKETS = gql`
  mutation BulkExpireTickets($tp_ids: [uuid!]!) {
    update_ticket_placement(
      where: {
        tp_id: { _in: $tp_ids }
        tp_is_published: { _eq: false }
        tp_status: { _in: [ToBeVerified, Verified] }
      }
      _set: { tp_status: Closed }
    ) {
      affected_rows
      returning {
        tp_id
      }
    }
  }
`;

export const GET_EXPIRED_TICKETS = gql`
  query GetExpiredTickets(
    $pageSize: Int = 5000,
    $pageOffset: Int = 0,
    $search_event: String = "%",
    $search_client: String = "%",
    $order_by: [getmanageticket_order_by!],
    $startdate: date,
    $enddate: date,
    $startDateTime: timestamptz,
    $endDateTime: timestamptz,
    $leagueId: uuid
  ) {
    filterreturntickets: filtermanagetickets(
      args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:null, tpid:null, array_tpid:null, ticket_status:null, day:null}
      where: {
        tp_status: {_eq: "Closed"},
        _and:[
          {_or:[
            {e_name:{_ilike:$search_event}},
            {e_address:{_ilike:$search_event}},
            {l_name:{_ilike:$search_event}}
          ]},
          {_or:[
            {full_name:{_ilike:$search_client}},
            {u_email_id:{_ilike:$search_client}},
            {u_original_email:{_ilike:$search_client}}
          ]}
        ]
      }
      limit: $pageSize
      offset: $pageOffset
      order_by: $order_by
    ) {
      e_name
      l_name
      e_date
      e_address
      tp_section
      tp_row
      tp_seat_no
      tp_internal_notes
      tp_external_notes
      lc_id
      u_id
      u_first_name
      u_last_name
      u_pricing_mode
      ticket_user {
        u_fee_percentage
      }
      e_id
      t_id
      tp_id
      u_full_name: full_name
      u_email_id
      tp_list_price
      tp_status
      u_original_email
      e_brand_name
      e_status
      e_time_zone
      e_date_time_zone
      tp_delist_requested_email
      tp_updated_at
      tp_is_support_vanderbilt_nil_fund
      tp_barcode
    tp_barcode
      u_pricing_mode
    }
    filterreturntickets_aggregate: filtermanagetickets_aggregate(
      args: {enddate:$enddate, leagueid:$leagueId, startdate:$startdate, ticketid:null, tpid:null, array_tpid:null, ticket_status:null, day:null}
      where: {
        tp_status: {_eq: "Closed"},
        _and:[
          {_or:[
            {e_name:{_ilike:$search_event}},
            {e_address:{_ilike:$search_event}},
            {l_name:{_ilike:$search_event}}
          ]},
          {_or:[
            {full_name:{_ilike:$search_client}},
            {u_email_id:{_ilike:$search_client}},
            {u_original_email:{_ilike:$search_client}}
          ]}
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    closed_placement_aggregate: ticket_placement_aggregate(
      where: {
        tp_status: { _eq: Closed }
        tp_deleted_at: { _is_null: true }
        _and: [
          {
            _or: [
              { ticket: { event: { e_name: { _ilike: $search_event } } } },
              { ticket: { event: { e_address: { _ilike: $search_event } } } }
            ]
          },
          {
            _or: [
              { ticket: { user: { u_first_name: { _ilike: $search_client } } } },
              { ticket: { user: { u_last_name: { _ilike: $search_client } } } },
              { ticket: { user: { u_email_id: { _ilike: $search_client } } } },
              { ticket: { user: { u_original_email: { _ilike: $search_client } } } }
            ]
          },
          {
            ticket: { event: { e_date: { _gte: $startDateTime, _lte: $endDateTime } } }
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    closed_orphan_placements: ticket_placement(
      where: {
        tp_status: { _eq: Closed }
        tp_deleted_at: { _is_null: true }
        _and: [
          {
            _or: [
              { ticket: { event: { e_name: { _ilike: $search_event } } } },
              { ticket: { event: { e_address: { _ilike: $search_event } } } }
            ]
          },
          {
            _or: [
              { ticket: { user: { u_first_name: { _ilike: $search_client } } } },
              { ticket: { user: { u_last_name: { _ilike: $search_client } } } },
              { ticket: { user: { u_email_id: { _ilike: $search_client } } } },
              { ticket: { user: { u_original_email: { _ilike: $search_client } } } }
            ]
          },
          {
            ticket: { event: { e_date: { _gte: $startDateTime, _lte: $endDateTime } } }
          }
        ]
      }
      limit: $pageSize
      offset: $pageOffset
    ) {
      tp_id
      t_id
      tp_section
      tp_row
      tp_seat_no
      tp_internal_notes
      tp_external_notes
      tp_list_price
      tp_status
      tp_updated_at
      tp_delist_requested_email
      tp_is_support_vanderbilt_nil_fund
      tp_barcode
    tp_barcode
      ticket {
        u_id
        event {
          e_id
          e_name
          e_date
          e_address
          e_brand_name
          e_status
          e_time_zone
          e_date_time_zone
        }
        user {
          u_id
          u_first_name
          u_last_name
          u_email_id
          u_original_email
          u_pricing_mode
          u_fee_percentage
        }
      }
    }
  }
`;

export const GET_FAILED_TRANSFER_TICKETS = gql`
  query GetFailedTransferTickets(
    $pageSize: Int = 5000,
    $pageOffset: Int = 0,
    $search_event: String = "%",
    $search_client: String = "%",
    $order_by: [getmanageticket_order_by!]
  ) {
    filtermanagetickets(
      args: {enddate:null, leagueid:null, startdate:null, ticket_status:"ToBeVerified", day:null, ticketid:null, tpid:null, array_tpid:null}
      where: {
        tp_is_published:{_eq:false},
        tp_status:{_eq:"ToBeVerified"},
        _and:[
          {_or:[
            {e_name:{_ilike:$search_event}},
            {e_address:{_ilike:$search_event}},
            {l_name:{_ilike:$search_event}}
          ]},
          {_or:[
            {full_name:{_ilike:$search_client}},
            {u_email_id:{_ilike:$search_client}},
            {u_original_email:{_ilike:$search_client}}
          ]}
        ]
      }
      limit: $pageSize
      offset: $pageOffset
      order_by: $order_by
    ) {
      e_name
      l_name
      e_date
      e_address
      tp_section
      tp_row
      tp_seat_no
      tp_internal_notes
      tp_external_notes
      lc_id
      tp_status
      tp_list_price
      u_id
      u_first_name
      u_last_name
      e_id
      t_id
      tp_id
      u_full_name: full_name
      u_email_id
      u_original_email
      e_brand_name
      e_status
      e_time_zone
      e_date_time_zone
      tp_delist_requested_email
      tp_updated_at
      tp_is_support_vanderbilt_nil_fund
      tp_barcode
    tp_barcode
      u_pricing_mode
      ticket_user {
        u_fee_percentage
      }
    }
    filtermanagetickets_aggregate(
      args: {enddate:null, leagueid:null, startdate:null, ticket_status:"ToBeVerified", day:null, ticketid:null, tpid:null, array_tpid:null}
      where: {
        tp_is_published:{_eq:false},
        tp_status:{_eq:"ToBeVerified"},
        _and:[
          {_or:[
            {e_name:{_ilike:$search_event}},
            {e_address:{_ilike:$search_event}},
            {l_name:{_ilike:$search_event}}
          ]},
          {_or:[
            {full_name:{_ilike:$search_client}},
            {u_email_id:{_ilike:$search_client}},
            {u_original_email:{_ilike:$search_client}}
          ]}
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const MARK_TICKETS_AS_SOLD = gql`
  mutation MarkTicketsAsSold($ticketPlacementIds: [String!]!) {
    markTicketsAsSold(ticketPlacementIds: $ticketPlacementIds) {
      message
      success
      failedIds
    }
  }
`;

export const DELIST_TICKETS = gql`
  mutation DelistTickets($ticketPlacementIds: [uuid!]!, $requestedEmailId: String!) {
    delistTickets(delistTicketsInput: { 
      ticketPlacementIds: $ticketPlacementIds, 
      requestedEmailId: $requestedEmailId 
    }) {
      message
    }
  }
`;

export const DELIST_TICKET_BY_ADMIN = gql`
mutation DelistTicketByAdmin ($ticketPlacementId: uuid!) {
  delistTicketByAdmin(ticketPlacementId: $ticketPlacementId) {
    message
  }
}
`;

export const EDIT_TICKET_PRICE_BY_SUPER_USER = gql`
  mutation EditTicketPriceBySuperUser($tp_ids: [uuid!]!, $tp_list_price: Float!) {
    editTicketPriceBySuperUser(
      editTicketPriceInput: { ticketPlacementIds: $tp_ids, tp_list_price: $tp_list_price }
    ) {
      message
      requiresConfirmation
    }
  }
`;

export const PUBLISH_NON_VL_LISTING = gql`
  mutation PublishNonVlListing($tp_ids: [uuid!]!, $tp_list_price: float8!) {
    update_ticket_placement(
      where: { tp_id: { _in: $tp_ids } }
      _set: {
        tp_status: List
        tp_is_published: true
        tp_validity_status: true
        tp_deleted_at: null
        tp_list_price: $tp_list_price
        tp_delist_requested_email: null
        tp_barcode_attached: false
        on_hold: false
      }
    ) {
      affected_rows
      returning {
        tp_id
        tp_status
        tp_list_price
        tp_is_published
        tp_validity_status
        tp_deleted_at
        tp_delist_requested_email
        tp_pricing_method
        tp_barcode_attached
        on_hold
      }
    }
  }
`;

export const GET_MARKETPLACES_FOR_TICKETS = gql`
  query GetMarketplacesForTickets {
    marketplaces(where: { active: { _eq: true } }, order_by: { name: asc }) {
      id
      name
      vl_fee_percentage
      active
    }
  }
`;

export const GET_TICKET_MARKETPLACES_BY_TP_IDS = gql`
  query GetTicketMarketplacesByTpIds($tpIds: [uuid!]!) {
    ticket_placement(where: { tp_id: { _in: $tpIds } }) {
      tp_id
      tp_marketplace_name
    }
  }
`;

export const GET_VL_LISTING_IDS_BY_TP_IDS = gql`
  query GetVlListingIdsByTpIds($tpIds: [uuid!]!) {
    ticket_placement(where: { tp_id: { _in: $tpIds } }) {
      tp_id
      tp_vl_listing_id
      tp_vl_item_id
      tp_wrong_pid
    }
  }
`;

export const GET_PLACEMENT_VL_PRODUCTION_IDS = gql`
  query GetPlacementVlProductionIds($tpIds: [uuid!]!) {
    ticket_placement(where: { tp_id: { _in: $tpIds } }) {
      tp_id
      tp_vl_production_id
      tp_stubhub_id
      tp_seatgeek_id
    }
  }
`;

export const GET_TICKET_GROUPING_BOUNDARIES = gql`
  query GetTicketGroupingBoundaries($listingIds: [String!]!, $ticketIds: [uuid!]!) {
    ticket_placement(
      where: {
        _or: [
          { tp_vl_listing_id: { _in: $listingIds } }
          { t_id: { _in: $ticketIds } }
        ]
      }
      limit: 5000
    ) {
      tp_id
      t_id
      tp_vl_listing_id
      tp_status
      tp_payment_status
      tp_seat_no
      tp_section
      tp_row
    }
  }
`;

export const GET_SIBLING_TAB_COUNTS = gql`
  query GetSiblingTabCounts(
    $enddate: date
    $leagueId: uuid
    $startdate: date
    $search_event: String = "%"
    $search_client: String = "%"
    $array_tpid: jsonb
    $pricingMode: String = "%"
    $startDateTime: timestamptz
    $endDateTime: timestamptz
  ) {
    filterlisttickets_aggregate(
      args: {
        enddate: $enddate
        leagueid: $leagueId
        startdate: $startdate
        ticketid: null
        tpid: null
        array_tpid: $array_tpid
        ticket_status: null
        payment_status: null
      }
      where: {
        tp_status: { _eq: "List" }
        tp_is_published: { _eq: true }
        u_pricing_mode: { _ilike: $pricingMode }
        _and: [
          { _or: [{ e_name: { _ilike: $search_event } }, { e_address: { _ilike: $search_event } }, { l_name: { _ilike: $search_event } }] }
          { _or: [{ full_name: { _ilike: $search_client } }, { u_email_id: { _ilike: $search_client } }, { u_original_email: { _ilike: $search_client } }] }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    FilterSoldTickets_aggregate: filterlisttickets_aggregate(
      args: {
        enddate: $enddate
        leagueid: $leagueId
        startdate: $startdate
        ticketid: null
        tpid: null
        array_tpid: $array_tpid
        ticket_status: null
        payment_status: null
      }
      where: {
        tp_is_published: { _eq: true }
        tp_status: { _eq: "Sold" }
        u_pricing_mode: { _ilike: $pricingMode }
        _and: [
          { _or: [{ e_name: { _ilike: $search_event } }, { e_address: { _ilike: $search_event } }, { l_name: { _ilike: $search_event } }] }
          { _or: [{ full_name: { _ilike: $search_client } }, { u_email_id: { _ilike: $search_client } }, { u_original_email: { _ilike: $search_client } }] }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    FilterDelisted_allTab_aggregate: filtermanagetickets_aggregate(
      args: {
        enddate: $enddate
        leagueid: $leagueId
        startdate: $startdate
        ticketid: null
        tpid: null
        array_tpid: $array_tpid
        ticket_status: null
        day: null
      }
      where: {
        tp_status: { _in: ["Delist", "DelistInProgress", "DelistRequested", "Return"] }
        u_pricing_mode: { _ilike: $pricingMode }
        _and: [
          { _or: [{ e_name: { _ilike: $search_event } }, { e_address: { _ilike: $search_event } }, { l_name: { _ilike: $search_event } }] }
          { _or: [{ full_name: { _ilike: $search_client } }, { u_email_id: { _ilike: $search_client } }, { u_original_email: { _ilike: $search_client } }] }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    filterUnsoldTickets_aggreagate: filtermanagetickets_aggregate(
      args: {
        enddate: $enddate
        leagueid: $leagueId
        startdate: $startdate
        ticketid: null
        tpid: null
        array_tpid: $array_tpid
        ticket_status: null
        day: null
      }
      where: {
        tp_status: { _in: ["Unsold"] }
        u_pricing_mode: { _ilike: $pricingMode }
        _and: [
          { _or: [{ e_name: { _ilike: $search_event } }, { e_address: { _ilike: $search_event } }, { l_name: { _ilike: $search_event } }] }
          { _or: [{ full_name: { _ilike: $search_client } }, { u_email_id: { _ilike: $search_client } }, { u_original_email: { _ilike: $search_client } }] }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    filterListingRequestCancelledTickets_aggregate: filtermanagetickets_aggregate(
      args: {
        enddate: $enddate
        leagueid: $leagueId
        startdate: $startdate
        ticketid: null
        tpid: null
        array_tpid: $array_tpid
        ticket_status: null
        day: null
      }
      where: {
        tp_status: { _in: ["ListingRequestCancelled"] }
        u_pricing_mode: { _ilike: $pricingMode }
        _and: [
          { _or: [{ e_name: { _ilike: $search_event } }, { e_address: { _ilike: $search_event } }, { l_name: { _ilike: $search_event } }] }
          { _or: [{ full_name: { _ilike: $search_client } }, { u_email_id: { _ilike: $search_client } }, { u_original_email: { _ilike: $search_client } }] }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    closed_placement_aggregate: ticket_placement_aggregate(
      where: {
        tp_status: { _eq: Closed }
        tp_deleted_at: { _is_null: true }
        _and: [
          {
            _or: [
              { ticket: { event: { e_name: { _ilike: $search_event } } } }
              { ticket: { event: { e_address: { _ilike: $search_event } } } }
            ]
          }
          {
            _or: [
              { ticket: { user: { u_first_name: { _ilike: $search_client } } } }
              { ticket: { user: { u_last_name: { _ilike: $search_client } } } }
              { ticket: { user: { u_email_id: { _ilike: $search_client } } } }
              { ticket: { user: { u_original_email: { _ilike: $search_client } } } }
            ]
          }
          { ticket: { event: { e_date: { _gte: $startDateTime, _lte: $endDateTime } } } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_COUNTS_FOR_ALL_TABS = GET_SIBLING_TAB_COUNTS;

export const GET_DELETED_TICKETS = gql`
query FilterDeletedTickets (
  $enddate: timestamptz,
  $startdate: timestamptz,
  $pageSize: Int,
  $pageOffset: Int,
  $order_by: [ticket_placement_order_by!],
  $search_event: String = "%",
  $search_client: String = "%",
  $array_tpid: jsonb,
  $pricingMode: String = "%"
) {
  ticket_placement(
    where: {
      _and: [
        { tp_status: { _eq: Deleted } },
        { ticket: { event: { e_date: { _gte: $startdate } } } },
        { ticket: { event: { e_date: { _lte: $enddate } } } },
        { ticket: { event: { e_name: { _ilike: $search_event } } } },
        { ticket: { user: { u_email_id: { _ilike: $search_client } } } },
        { ticket: { user: { u_pricing_mode: { _ilike: $pricingMode } } } }
      ]
    }
    limit: $pageSize
    offset: $pageOffset
    order_by: $order_by
  ) {
    tp_id
    tp_section
    tp_row
    tp_seat_no
    tp_internal_notes
    tp_external_notes
    tp_list_price
    tp_status
    tp_updated_at
    tp_is_support_vanderbilt_nil_fund
    tp_barcode
    ticket {
      t_id
      e_id: event { e_id }
      event {
        e_id
        e_name
        e_address
        e_date
        e_brand_name
        e_status
        e_time_zone
        e_date_time_zone
        l_id
      }
      user {
        u_id
        u_first_name
        u_last_name
        u_full_name
        u_email_id
        u_original_email
        u_pricing_mode
        u_fee_percentage
      }
    }
  }

  ticket_placement_aggregate(
    where: {
      _and: [
        { tp_status: { _eq: Deleted } },
        { ticket: { event: { e_date: { _gte: $startdate } } } },
        { ticket: { event: { e_date: { _lte: $enddate } } } },
        { ticket: { event: { e_name: { _ilike: $search_event } } } },
        { ticket: { user: { u_email_id: { _ilike: $search_client } } } },
        { ticket: { user: { u_pricing_mode: { _ilike: $pricingMode } } } }
      ]
    }
  ) {
    aggregate {
      count
    }
  }
}
`;

export const DELETE_TICKET_STATUS = gql`
  mutation DeleteTicketStatus($tp_id: uuid!) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id } }
      _set: { tp_status: Deleted, tp_is_published: false }
    ) {
      returning {
        tp_id
        tp_status
        tp_is_published
      }
    }
  }
`;


export const RESTORE_DELETED_TO_VERIFICATION = gql`
  mutation RestoreDeletedToVerification($tp_id: uuid!, $updated_at: timestamptz!) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id } }
      _set: {
        tp_status: ToBeVerified
        tp_is_published: false
        tp_validity_status: null
        tp_deleted_at: null
        tp_delist_requested_email: null
        tp_updated_at: $updated_at
      }
    ) {
      returning {
        tp_id
        tp_status
        tp_is_published
        tp_validity_status
        tp_deleted_at
        tp_delist_requested_email
      }
    }
  }
`;

export const UPDATE_TICKET_COMMISSION_OVERRIDE = gql`
  mutation UpdateTicketCommissionOverride(
    $tp_id: uuid!
    $commissionOverride: numeric
  ) {
    update_ticket_placement(
      where: { tp_id: { _eq: $tp_id } }
      _set: { tp_sales_rep_commission_override: $commissionOverride }
    ) {
      affected_rows
      returning {
        tp_id
        tp_sales_rep_commission_override
      }
    }
  }
`;

export const UPDATE_TICKET_BARCODE_STATUS = gql`
  mutation UpdateTicketBarcodeStatus($tpIds: [uuid!]!, $status: String!) {
    update_ticket_placement(
      where: { tp_id: { _in: $tpIds } }
      _set: { tp_barcode_status_override: $status }
    ) {
      affected_rows
    }
  }
`;
/** Separate from the Listed query so the tab still loads where the table is missing. */
export const GET_VL_SUPPORT_REQUESTS_BY_TP_IDS = gql`
  query GetVlSupportRequestsByTpIds($tpIds: [uuid!]!) {
    vl_support_request(where: { tp_id: { _in: $tpIds } }, order_by: { vsr_sent_at: desc }) {
      vsr_id
      tp_id
      vsr_type
      vsr_marketplaces
      vsr_status
      vsr_sent_at
      vsr_sent_by_email
      vsr_owner_initials
      vsr_completed_at
      vsr_ticket_id
      ticket { vst_id vst_unread_count }
    }
  }
`;
